import { render, staticRenderFns } from "./StatusComponents.vue?vue&type=template&id=5c715228&scoped=true&"
import script from "./StatusComponents.vue?vue&type=script&lang=js&"
export * from "./StatusComponents.vue?vue&type=script&lang=js&"
import style0 from "./StatusComponents.vue?vue&type=style&index=0&id=5c715228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c715228",
  null
  
)

export default component.exports